// extracted by mini-css-extract-plugin
export default {"faq-page":"Index_faq-page__up7yP","faq-page__info":"Index_faq-page__info__4hrG6"};